import { useState, useEffect } from 'react';

export type ConsentStatus = 'granted' | 'denied' | null;

export function useCookieConsent() {
	const [consent, setConsent] = useState<ConsentStatus>(null);
	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		setIsMounted(true);
		const storedConsent = localStorage.getItem('cookie-consent');
		if (storedConsent === 'granted' || storedConsent === 'denied') {
			setConsent(storedConsent as ConsentStatus);

			// Restore consent to Google Analytics on page load
			if (typeof window !== 'undefined' && 'gtag' in window) {
				// @ts-ignore
				window.gtag('consent', 'update', {
					ad_storage: storedConsent,
					ad_user_data: storedConsent,
					ad_personalization: storedConsent,
					analytics_storage: storedConsent,
				});
			}
		}
	}, []);

	const updateConsent = (status: ConsentStatus) => {
		if (!status) return;
		localStorage.setItem('cookie-consent', status);
		setConsent(status);

		// Update Google Analytics Consent
		if (typeof window !== 'undefined' && 'gtag' in window) {
			// @ts-ignore
			window.gtag('consent', 'update', {
				ad_storage: status,
				ad_user_data: status,
				ad_personalization: status,
				analytics_storage: status,
			});
		}
	};

	return { consent, updateConsent, isMounted };
}
